export enum AnalyticsEventFields {
  QuotingPetIdx = 'quoting_pet_idx',
  QuotingNumOfPets = 'quoting_number_of_pets',
}
